<template>
  <div class="columns">

    <div class="column">
      <sc-field label="Ocorrências">
        <sc-reports-occurrences-dropdown v-model="filters.occurrence" />
      </sc-field>
    </div>

    <div class="column">
      <sc-field label="Visão">
        <sc-select
          v-model="filters.vision"
          placeholder="Selecione"
          expanded>
          <option
            v-for="vision in visionsList"
            :key="vision.value"
            :value="vision.value">
            {{ vision.label }}
          </option>
        </sc-select>
      </sc-field>
    </div>

    <div class="column">
      <sc-field label="Estado" prop="region">
        <sc-state
          v-model="filters.region"
          :is-uf="false"
          :option-all="true" />
      </sc-field>
    </div>

    <div class="column">
      <sc-field label="Tipo de período">
        <sc-select
          v-model="filters.period"
          placeholder="Selecione"
          expanded>
          <option
            v-for="period in periodsList"
            :key="period.value"
            :value="period.value">
            {{ period.label }}
          </option>
        </sc-select>
      </sc-field>
    </div>

    <div class="column">
      <sc-field label="Período">
        <sc-range-date-picker
          v-model="filters.dateRange"
          :max-date="maxDate"
          :format="formatDateRange"
          class="is-small"/>
      </sc-field>
    </div>

  </div>
</template>

<script>
  import { Moment } from '@intelipost-js/secure-providers';
  import {
    ScField,
    ScSelect,
    ScRangeDatePicker,
    ScState,
  } from '@intelipost-js/secure-components';
  import ScReportsOccurrencesDropdown from '../../../../components/sc-reports-occurrences-dropdown/ScReportsOccurrencesDropdown';

  export default {
    name: 'sc-report-filters',
    props: {
      filters: {
        type: Object,
        required: true,
      },
    },
    data() {
      return {
        maxDate: Moment().toDate(),
        visionsList: [
          {
            label: 'Data - Cliente',
            value: 'user',
          },
          {
            label: 'Data - Transportadora',
            value: 'logistic_provider',
          },
        ],
        periodsList: [
          {
            label: 'Data de criação',
            value: 'CREATED_DATE',
          },
          {
            label: 'Data prevista',
            value: 'ESTIMATED_DATE',
          },
          {
            label: 'Data de entrega',
            value: 'DELIVERED_DATE',
          },
        ],
      };
    },
    methods: {
      formatDateRange(dateRange) {
        return {
          start: Moment(dateRange.start).format('YYYY-MM-DD'),
          end: Moment(dateRange.end).format('YYYY-MM-DD'),
        };
      },
    },
    components: {
      ScField,
      ScSelect,
      ScRangeDatePicker,
      ScState,
      ScReportsOccurrencesDropdown,
    },
  };
</script>



// WEBPACK FOOTER //
// node_modules/@intelipost-modules/secure-analytic/features/reports/pages/performance/components/sc-report-performance-filters/ScReportPerformanceFilters.vue?12218c46